export default __webpack_public_path__ + "static/media/typePickup.876d3eb2.876d3eb2.svg";